<template>
    <div class="nav-box">
        <el-scrollbar>
            <div class="list">
                <div class="at" v-for="(item, index) in tabList" :key="item.dictValue"
                    :class="[item.dictValue === tabId ? 'tabActive' : '', 'swiper-slide']"
                    @click="tabClick(item, index)">
                    {{ item.dictLabel }}
                </div>
            </div>
        </el-scrollbar>
    </div>
</template>
<script>
export default {
    props: {
        tabList: {
            type: Array,
            default: () => [],
        },
        tabId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {};
    },
    watch: {},
    created() { },
    mounted() {

    },
    methods: {
        tabClick(item, index) {
            this.$emit("tabClick", item, index);
        },
    },
};
</script>
<style lang="scss" scoped>
.nav-box {
    width: 100%;
    height: 100%;

    .list {
        width: 100%;
        height: 100%;
        display: flex;
        gap: 0 10px;

        .at {
            width: 120px;
            text-align: center;
            margin-right: 10px;
            background-color: #e5e5e5;
            background-color: #e2e2e2;
            line-height: 40px;
            font-size: 14px;
            cursor: pointer;
            transition: all 0.3s;
            user-select: none;
        }

        .tabActive {
            background-color: $menu-active-color;
            color: $bg-color1;
        }
    }

    &::-webkit-scrollbar {
        display: none;
    }



}
</style>